import React from 'react'

import "./header.styles.css"

export default function Header() {
    return (
        <header className="container">
            <nav className="text-center display-4 main-heading">
                JSON Formatter & Validator
            </nav>
        </header>
    )
}
